import { createIcon } from '../icons/utils';

/**
 * Legacy ProgressBars' call glyph: a handset inside a filled ring (`call-circle.svg`).
 *
 * The ring is part of the artwork, exactly as legacy shipped it — which is why this
 * sits on the lane directly rather than on a white tile, like the status glyphs.
 * Legacy's `#009999` stroke is this theme's `--primary-600` to the digit, and its
 * `#D9F0F0` fill is `--primary-100`, so the port is tokens, not literals.
 *
 * Fixed-colour: legacy drew every communication circle in the same teal whatever the
 * transmission priority, so this ignores the caller's colour classes.
 */
export const CallCircleIcon = createIcon(
  ({ ref, className, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12.5 24C18.8513 24 24 18.8513 24 12.5C24 6.14873 18.8513 1 12.5 1C6.14873 1 1 6.14873 1 12.5C1 18.8513 6.14873 24 12.5 24Z"
        fill="hsl(var(--primary-100))"
        stroke="hsl(var(--primary-600))"
        strokeWidth={1.2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0301 16.9792C18.0301 17.2042 17.9801 17.4354 17.8738 17.6604C17.7676 17.8854 17.6301 18.0979 17.4488 18.2979C17.1426 18.6354 16.8051 18.8792 16.4238 19.0354C16.0488 19.1917 15.6426 19.2729 15.2051 19.2729C14.5676 19.2729 13.8863 19.1229 13.1676 18.8167C12.4488 18.5104 11.7301 18.0979 11.0176 17.5792C10.2988 17.0542 9.61758 16.4729 8.96758 15.8292C8.32383 15.1792 7.74258 14.4979 7.22383 13.7854C6.71133 13.0729 6.29883 12.3604 5.99883 11.6542C5.69883 10.9417 5.54883 10.2604 5.54883 9.61045C5.54883 9.18545 5.62383 8.7792 5.77383 8.4042C5.92383 8.02295 6.16133 7.67295 6.49258 7.36045C6.89258 6.9667 7.33008 6.77295 7.79258 6.77295C7.96758 6.77295 8.14258 6.81045 8.29883 6.88545C8.46133 6.96045 8.60508 7.07295 8.71758 7.23545L10.1676 9.2792C10.2801 9.43545 10.3613 9.5792 10.4176 9.7167C10.4738 9.84795 10.5051 9.9792 10.5051 10.0979C10.5051 10.2479 10.4613 10.3979 10.3738 10.5417C10.2926 10.6854 10.1738 10.8354 10.0238 10.9854L9.54883 11.4792C9.48008 11.5479 9.44883 11.6292 9.44883 11.7292C9.44883 11.7792 9.45508 11.8229 9.46758 11.8729C9.48633 11.9229 9.50508 11.9604 9.51758 11.9979C9.63008 12.2042 9.82383 12.4729 10.0988 12.7979C10.3801 13.1229 10.6801 13.4542 11.0051 13.7854C11.3426 14.1167 11.6676 14.4229 11.9988 14.7042C12.3238 14.9792 12.5926 15.1667 12.8051 15.2792C12.8363 15.2917 12.8738 15.3104 12.9176 15.3292C12.9676 15.3479 13.0176 15.3542 13.0738 15.3542C13.1801 15.3542 13.2613 15.3167 13.3301 15.2479L13.8051 14.7792C13.9613 14.6229 14.1113 14.5042 14.2551 14.4292C14.3988 14.3417 14.5426 14.2979 14.6988 14.2979C14.8176 14.2979 14.9426 14.3229 15.0801 14.3792C15.2176 14.4354 15.3613 14.5167 15.5176 14.6229L17.5863 16.0917C17.7488 16.2042 17.8613 16.3354 17.9301 16.4917C17.9926 16.6479 18.0301 16.8042 18.0301 16.9792Z"
        stroke="hsl(var(--primary-600))"
        strokeWidth={0.9375}
        strokeMiterlimit={10}
      />
      <path
        d="M15.8613 11.1479C15.8613 10.7729 15.5676 10.1979 15.1301 9.7292C14.7301 9.29795 14.1988 8.96045 13.6738 8.96045"
        stroke="hsl(var(--primary-600))"
        strokeWidth={0.9375}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0488 11.1479C18.0488 8.7292 16.0926 6.77295 13.6738 6.77295"
        stroke="hsl(var(--primary-600))"
        strokeWidth={0.9375}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  { displayName: 'CallCircleIcon', defaultSize: 25, classNameBase: '' },
);
